module.exports = __webpack_public_path__ + "static/media/agarose-gel-side-view.cbaa5b01.svg";